import VmsSiteService from "@/services/vms/site.service";

export const vmsSite = {
    state: () => ({ 
       stateName: "VmsSiteActivation", 
    }),
    namespaced: true,
    actions: {
        view({ commit }, request) {
            return VmsSiteService.view(request)
        },
        company({ commit }) {
            return VmsSiteService.company()
            .then(
                response => {
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        create({ commit, state }, request) {
            return VmsSiteService.create(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/insertRecordToPaginator", {
                            stateName: state.stateName,
                            dataToInsert: response.data.data
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        activate({ commit, state }, request) {
            return VmsSiteService.activate(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        deactivate({ commit, state }, request) {
            return VmsSiteService.deactivate(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
        updateModule({ commit, state }, request) {
            return VmsSiteService.updateModule(request)
            .then(
                response => {
                    if(response.status === 200 && response.data.data) {
                        commit("paginator/updateRecordInPaginator", {
                            stateName: state.stateName,
                            dataToUpdate: response.data.data,
                        }, { root: true });
                    }
                    return Promise.resolve(response);
                },
                error => {
                    return Promise.reject(error);
                }
            )
        },
    },
    mutations: {},
    getters: {
        getStateName(state) {
            return state.stateName;
        }
    }
};